const isRecurring = quantity => {
  return parseInt(quantity) === 0
}

export default isRecurring
